<script setup>
import ChannelSelector from '../ChannelSelector.vue';

const props = defineProps({
  channel: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['channelItemClick']);

const onItemClick = () => {
  emit('channelItemClick', props.channel.key);
};
</script>

<template>
  <ChannelSelector
    :title="channel.title"
    :description="channel.description"
    :icon="channel.icon"
    @click="onItemClick"
  />
</template>
